export const EducationDetailsData = [
  {
    icon:"bi:stars",
    title:'High-quality Production',
    titleAR:'انتاج تعليمي احترافي',
    disc:"We produce and edit educational videos with professional standards, delivering clear, engaging content that keeps learners focused.",
    discAR:"نُنتج ونحرر الفيديوهات التعليمية بمعايير احترافية لنقدّم محتوى واضحًا وجذابًا يحافظ على تركيز المتعلم.",
    link:"/virtual-project-page"
  },
  {
    icon:"carbon:cloud-service-management",
    title:'Custom E-learning Platforms',
    titleAR:'منصات تعليمية مبتكرة',
    disc:"We build custom LMS platforms tailored to your content and audience, ensuring secure, scalable, and branded learning solutions.",
    discAR:" نطوّر منصات تعليم إلكتروني مخصص تناسب محتواك وجمهورك، لتقدّم حلول تعلم آمنة وقابلة للتوسع متوافقة مع هويتك",
    link:"/project-management-page"

  },
  {
    icon:"fluent:content-view-28-regular",
    title:'Learner Centered Design',
    titleAR:'تصميم يركز على المتعلم',
    disc:"Our UX/UI designs are smooth and intuitive, creating user-friendly learning experiences that keep learners engaged with the content",
    discAR:" نصمّم واجهات استخدام سلسة وبديهية لتجارب تعليمية مريحة تُبقي تركيز المتعلم على المحتوى.",
    
    link:'/electronic-marketing-page'
  },
  {
    icon:"nimbus:marketing" ,
    title:'Advanced Content Security',
    titleAR:'محتوى متقدم آمن',
    disc:"We protect your educational content with advanced security protocols, preventing copying, leaks, and piracy.",
    discAR:" نؤمّن المحتوى التعليمي ببروتوكولات حماية متقدمة تمنع النسخ أو التسريب أو القرصنة",
    link:"/rigister-training-content"
  }
  ,
  {
    icon:'fluent:tablet-laptop-24-regular' ,
    title:'Strategic Marketing Support',
    titleAR:'تسويق تعليمي استراتيجي',
    disc:" We create tailored marketing campaigns that position your courses online and help reach the right audience",
    discAR:"نقدّم حملات تسويقية مخصصة تعزز ظهور كورساتك أونلاين وتوصلها للجمهور المستهدف",
    link:'/training-bags-page'
  }
  ,
  {
    icon:"fluent-mdl2:manager-self-service" ,
    title:'Comprehensive Support',
    titleAR:'دعم فني شامل',
    disc:"We provide complete technical support, guiding learners from their first login to their final certification",
    discAR:"نوفّر دعمًا فنيًا متكاملًا يغطي رحلة المتعلم من أول تسجيل دخول وحتى الحصول على الشهادة النهائية.",
    link:'/training-platform-page'
  }
]